if (!customElements.get("ysun-scroll")) {
  customElements.define(
    "ysun-scroll",
    class ysunScroll extends HTMLElement {
      constructor() {
        super();

        this.initGlobal();
        this.scrollEvent();
        this.initNavigationButton();
        this.initScrollBar();
      }

      /**
       * 初始化变量
       */
      initGlobal() {
        const layoutEl = this.querySelector(".ysun-scroll-layout");
        const boundingClientRect = layoutEl.getBoundingClientRect();
        const { width: layoutElW } = boundingClientRect || {};

        this.layoutEl = layoutEl;

        this.scrollEl = this.querySelector(".ysun-scroll-wrapper");

        // 滚动参数
        this.scroll = {
          w: layoutElW,
          left: 0,
          scrollBarElW: 0,
          scrollProgressElW: 0,
        };

        const scrollBarEl = this.querySelector(".ysun-scroll-bar");
        // 是否隐藏滚动条
        this.hiddenBar = !scrollBarEl;

        if (!this.hiddenBar) {
          this.scrollProgressEl = this.querySelector(
            ".ysun-scroll-progress"
          );

          const scrollBarElRect = scrollBarEl.getBoundingClientRect();
          const { width: scrollBarElW } = scrollBarElRect || {};
          this.scroll.scrollBarElW = scrollBarElW;
        }

        // 是否隐藏左右按钮
        const buttonEl = this.querySelector(".ysun-scroll-button-wrapper");
        this.hiddenButton = !buttonEl;

        // 鼠标/触摸操作事件
        this.moveData = {
          startX: null,
          startY: null,
          moveX: null,
          moveY: null,
          endX: null,
          endY: null,
        };
      }

      /**
       * 初始化事件
       */
      scrollEvent() {
        // 去掉默认的contextmenu事件，否则会和右键事件同时出现。
        this.layoutEl.addEventListener(
          "contextmenu",
          function (e) {
            e.preventDefault();
          },
          false
        );

        // 滚动事件
        this.scrollEl.addEventListener(
          "scroll",
          this.scrollModel.bind(this),
          false
        );

        // 鼠标/触摸 按下
        this.layoutEl.addEventListener(
          "mousedown",
          this.mouseDownEvent.bind(this),
          false
        );

        // 鼠标/触摸 移动
        this.layoutEl.addEventListener(
          "mousemove",
          this.mouseMoveEvent.bind(this),
          false
        );

        // 鼠标/触摸 释放
        this.layoutEl.addEventListener(
          "mouseup",
          this.mouseUpEvent.bind(this),
          false
        );
      }

      /**
       * 滚动监听
       */
      scrollModel() {
        if (!this.hiddenBar) {
          //  内容最大滚动距离
          const maxScrollLeft = this.scrollEl.scrollWidth - this.scroll.w;
          // 滚动条最大滚动距离
          const maxScrollBarLeft =
            this.scroll.scrollBarElW - this.scroll.scrollProgressElW;

          // 移动位移
          const left =
            (maxScrollBarLeft / maxScrollLeft) * this.scrollEl.scrollLeft;

          const x = this.moveTranslateX(Math.floor(left));
          const styleContent = `width:${this.scroll.scrollProgressElW}px;${x}`;
          this.scrollProgressEl.setAttribute("style", styleContent);
        }

        this.updateControlButton();
      }
      mouseDownEvent(e) {
        this.moveData.startX = e.x;
        this.moveData.startY = e.y;

        this.scroll.left = this.scrollEl.scrollLeft;
      }
      mouseMoveEvent(e) {
        if (this.moveData.startX === null || this.moveData.startY === null)
          return;

        this.moveData.moveX = e.x;
        this.moveData.moveY = e.y;

        const { startX, moveX } = this.moveData;
        this.scrollEl.scrollLeft = startX - moveX + this.scroll.left;
      }
      mouseUpEvent(e) {
        this.moveData.endX = e.x;
        this.moveData.endY = e.y;

        this.scroll.left = this.scrollEl.scrollLeft;

        // 清空鼠标/触摸记录
        this.moveData.startX = null;
        this.moveData.startY = null;
        this.moveData.moveX = null;
        this.moveData.moveY = null;
        this.moveData.endX = null;
        this.moveData.endY = null;
      }

      /**初始化右侧导航按钮*/
      initNavigationButton() {
        this.updateControlButton();
        this.btnLeftEvent();
        this.btnRightEvent();
      }

      // 同步按钮状态
      updateControlButton() {
        if (this.hiddenButton) return;

        const maxScrollLeft = this.scrollEl.scrollWidth - this.scroll.w;

        const carouselControlLeftEl = this.querySelector(
          ".ysun-scroll-button-left"
        );

        const carouselControlRightEl = this.querySelector(
          ".ysun-scroll-button-right"
        );

        if (this.scrollEl.scrollLeft <= 0) {
          addClass(carouselControlLeftEl, "disabled");
        } else {
          removeClass(carouselControlLeftEl, "disabled");
        }

        if (this.scrollEl.scrollLeft >= maxScrollLeft) {
          addClass(carouselControlRightEl, "disabled");
        } else {
          removeClass(carouselControlRightEl, "disabled");
        }
      }

      // 左侧按钮事件
      btnLeftModel() {
        const residue = this.scrollEl.scrollLeft;

        const scrollValue =
          residue > this.scroll.w ? this.scroll.w * 0.6 : residue;

        const startX = this.scrollEl.scrollLeft;
        const endX = this.scrollEl.scrollLeft - scrollValue;
        let value = startX;

        const interval = window.setInterval(() => {
          value -= 25;

          if (value <= endX) {
            value = endX;
            window.clearInterval(interval);
          }

          this.scrollEl.scrollLeft = value;
        }, 10);
      }
      btnLeftEvent() {
        if (this.hiddenButton) return;

        const carouselControlLeftEl = this.querySelector(
          ".ysun-scroll-button-left"
        );
        carouselControlLeftEl.addEventListener(
          "click",
          this.btnLeftModel.bind(this),
          false
        );
      }

      // 右侧按钮事件
      btnRightModel() {
        const maxScrollLeft = this.scrollEl.scrollWidth - this.scroll.w;
        const residue = maxScrollLeft - this.scrollEl.scrollLeft;
        const scrollValue =
          residue > this.scroll.w ? this.scroll.w * 0.6 : residue;

        const startX = 0;
        const endX = scrollValue;
        let value = startX;

        const interval = window.setInterval(() => {
          value += 25;

          if (value > endX) {
            value = endX;
            window.clearInterval(interval);
          }

          this.scrollEl.scrollLeft = value + this.scroll.left;
        }, 10);
      }
      btnRightEvent() {
        if (this.hiddenButton) return;

        const carouselControlRightEl = this.querySelector(
          ".ysun-scroll-button-right"
        );
        carouselControlRightEl.addEventListener(
          "click",
          this.btnRightModel.bind(this),
          false
        );
      }

      /**初始化滚动条*/
      initScrollBar() {
        if (this.hiddenBar) return;

        const width =
          (this.scroll.w / this.scrollEl.scrollWidth) *
          this.scroll.scrollBarElW;

        this.scroll.scrollProgressElW = Math.floor(width);

        const styleContent = `width:${this.scroll.scrollProgressElW}px;`;
        this.scrollProgressEl.setAttribute("style", styleContent);
      }

      /**
       * 移动X轴位移
       */
      moveTranslateX(x) {
        return `transform: translate3d(${x}px, 0, 0);-webkit-transform: translate3d(${x}px, 0, 0);`;
      }
    }
  );
}